<template>
  <div class="test-result">
    <content-box :min-height="'646px'">
      <scenario-list
          class="scenario-list"
          :scenarioList="scenarioList"
          @getTestResultList="getTestResults">
      </scenario-list>
      <test-result-list
          class="test-list"
          :testResultList="testResultList">
      </test-result-list>
    </content-box>
  </div>
</template>

<script>
import ScenarioList from "@/components/ScenarioList.vue";
import TestResultList from "@/components/TestResultList.vue";
import {getScenarioList, getTestResultList} from "@/api/probe";
import ContentBox from "@/components/ui/ContentBox.vue";
export default {
  name: 'TestResult',
  components: {
    ContentBox,
    TestResultList,
    ScenarioList,
  },
  created () {
    this.load()
  },
  computed: {
  },
  methods: {
    load() {
      getScenarioList(true).then((resp) => {
        this.scenarioList = resp.data.result
      })
    },
    getTestResults (scenarioId) {
      const param = {scenarioId: scenarioId}
      getTestResultList(param).then((resp) => {
        this.testResultList = resp.data.result
      })
    }
  },
  data () {
    return {
      scenarioList: [],
      testResultList: []
    }
  }
}
</script>

<style scoped lang="scss">
.test-result {
  margin-top: 20px;
  margin-bottom: 20px;
  .scenario-list {
    display: inline-block;
    vertical-align: top;
    width: 350px;
  }
  .test-list {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 350px);
  }
}
</style>
